<div aria-live="polite" class="search-result-info" [ngClass]="{ 'no-results': displayedSessions().length === 0 }">
	@if (searchTerm(); as searchTerm) {
		@if ($any(searchTerm).length > 0) {
			@if (isLoading() === false) {
				@if (displayedSessions().length; as total) {
					<span class="result-info-found"
						[innerHTML]="'session-list_search-result-found' | translate:
						{ 'searchedText': searchTerm, 'resultsCount': total }">
					</span>
				}
			} @else {
				<span class="searching">
					<span class="ficon-spinner ficon-spin"></span>
					<span
						translate="session-list_searching"
						[translateParams]="{searchedText: searchTerm}">
					</span>
				</span>
			}
		}
	} @else {
		@if (displayedSessions().length; as total) {
			<span class="result-info-default"
				translate="session-list_search-result-default"
				[translateParams]="{resultsCount: total}">
			</span>
		}
	}
</div>
